import type {
  SeriesDisplayMode,
  TooltipVariant,
} from '../../core/types/tooltip.js';

/**
 * Props for the TimeseriesChart.Tooltip slot component
 * @public
 */
export interface TimeseriesChartTooltipProps {
  /**
   * Whether the tooltip should contain datapoints from all series for the selected timestamp, or just the closest one.
   * @defaultValue 'single'
   */
  variant?: TooltipVariant;
  /** The tooltip items display mode. When it's undefined and variant is 'shared', then set to 'single-line', if variant is 'single', then set to 'multi-line'. */
  seriesDisplayMode?: SeriesDisplayMode;
}

/**
 * @public
 */
export const Tooltip = (props: TimeseriesChartTooltipProps) => null;

Tooltip['displayName'] = 'TimeseriesChart.Tooltip';
